var _a;
import { writable } from 'svelte/store';
const TIMESHEET_URL_STORAGE_KEY = 'timesheet-url';
const storedTimesheetUrl = (_a = localStorage.getItem(TIMESHEET_URL_STORAGE_KEY)) !== null && _a !== void 0 ? _a : '';
export const timesheetUrl = writable(storedTimesheetUrl);
timesheetUrl.subscribe(value => {
    localStorage.setItem(TIMESHEET_URL_STORAGE_KEY, value);
});
